export default function(digits = 20) {
  const parsedDigits = Number.parseInt(digits) || 20
  const result = []

  while (result.length < parsedDigits) {
    let randomDigits
    const crypto = window.crypto || window.msCrypto
    if (crypto) {
      const randomBytes = new Uint8Array(parsedDigits * 2) // account for bytes 250+ that are filtered out
      crypto.getRandomValues(randomBytes)
      randomDigits = randomBytes
        .filter(number => number < 250)
        .map(number => Math.floor(number / 25))
    } else {
      randomDigits = new Array(parsedDigits)
        .fill(0)
        .map(() => Math.floor(Math.random() * 10))
    }
    result.push(...randomDigits.slice(0, parsedDigits - result.length))
  }

  return result.join('')
}
